<div [ngClass]="getLoaderClasses()">
  <div class="loader-content">
    @if (effectiveConfig.type === 'spinner') {
      <div [ngClass]="getSpinnerClasses()">
        <div class="spinner-border" role="status"></div>
      </div>
    }

    @if (effectiveConfig.type === 'dots') {
      <div [ngClass]="getSpinnerClasses()">
        <div class="loader-dots">
          <div class="dot"></div>
          <div class="dot"></div>
          <div class="dot"></div>
        </div>
      </div>
    }

    @if (effectiveConfig.type === 'progress') {
      <div [ngClass]="getSpinnerClasses()">
        <div class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width: 100%"></div>
        </div>
      </div>
    }

    @if (effectiveConfig.text) {
      <div class="loader-text">
        {{ effectiveConfig.text }}
      </div>
    }
  </div>
</div>
